import { Component, ReactNode } from "react";

import {
  systemHasPermissions,
  customerHasPermissions,
  siteHasPermissions,
} from "../utils";
import { createCompositeSiteId } from "../../redux/modules/sites/reducer";

import type { AclState } from "../reducer";
import type { Customer } from "../../redux/modules/customers/reducer";
import type { Site } from "../../redux/modules/sites/reducer";

export interface AclConditionProps {
  acl: AclState;
  permissions: string[];
  ifTrue?: ReactNode;
  ifFalse?: ReactNode;
  customer?: Customer;
  site?: Site;
  children?: ReactNode;
};
export default class AclCondition extends Component<AclConditionProps> {
  render() {
    const {
      acl,
      customer,
      site,
      permissions,
      ifTrue,
      ifFalse,
      children,
    } = this.props;

    if (customer && customerHasPermissions(acl, permissions, customer.id)) {
      return ifTrue || children || null;
    }

    if (
      site &&
      siteHasPermissions(acl, permissions, createCompositeSiteId(site))
    ) {
      return ifTrue || children || null;
    }

    if (systemHasPermissions(acl, permissions)) {
      return ifTrue || children || null;
    }

    return ifFalse || null;
  }
}
